var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-box"},[_c('input',{ref:"text",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.url}}),_vm._v(" "),_c('button',{on:{"click":_vm.copy}},[_c('icon',{attrs:{"name":"chain-link","variant":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }